{
  "common": {
    "save": "Simpan",
    "cancel": "Batal",
    "back": "Kembali",
    "close": "Tutup",
    "loading": "Memuat…",
    "error_generic": "Terjadi kesalahan.",
    "error_network": "Jaringan bermasalah.",
    "not_found": "Halaman tidak ditemukan."
  },
  "lang": {
    "label": "Bahasa"
  },
  "units": {
    "day_one": "{count} hari",
    "day_other": "{count} hari",
    "hour_one": "{count} jam",
    "hour_other": "{count} jam",
    "minute_one": "{count} menit",
    "minute_other": "{count} menit",
    "second_one": "{count} detik",
    "second_other": "{count} detik",
    "d": "{count}h",
    "h": "{count}j",
    "m": "{count}m"
  },
  "og": {
    "join": "Ikut foto-foto di acara ini",
    "view": "Lihat foto-foto acara ini"
  },
  "events": {
    "wedding": "Pernikahan",
    "birthday": "Ulang Tahun",
    "baby_shower": "Baby Shower",
    "travel": "Perjalanan",
    "corporate": "Acara Perusahaan",
    "other": "Acara Lain"
  },
  "guest": {
    "opens_in": "Dibuka dalam {time}",
    "event_over": "Acara selesai",
    "camera_open": "Kamera terbuka",
    "load_failed": "Gagal memuat album. Coba muat ulang halaman.",
    "device_full": "Album sudah mencapai batas tamu. Hubungi panitia.",
    "your_photos": "Foto kamu",
    "no_photos": "Belum ada foto. Ambil foto pertamamu.",
    "photos_for_you_one": "{count} foto untukmu",
    "photos_for_you_other": "{count} foto untukmu",
    "opens_at": "Dibuka {date} · dalam {countdown}",
    "quota_used": "Kuota foto sudah habis. Hubungi panitia untuk menambah kuota.",
    "unsent_one": "{count} foto belum terkirim.",
    "unsent_other": "{count} foto belum terkirim.",
    "unsent_closed_one": "{count} foto tidak sempat terkirim, penerimaan foto sudah ditutup.",
    "unsent_closed_other": "{count} foto tidak sempat terkirim, penerimaan foto sudah ditutup.",
    "resend_all": "Kirim ulang semua",
    "processing": "Memproses foto…",
    "capture_failed": "Foto gagal diproses.",
    "join_failed": "Gagal masuk, coba lagi.",
    "load_more": "Muat lebih",
    "guest_fallback": "tamu",
    "by_name": "oleh {name}",
    "status": {
      "queued": "menunggu",
      "uploading": "mengirim",
      "failed": "gagal, ketuk untuk kirim ulang",
      "quota": "kuota habis, ketuk kirim ulang setelah panitia menambah kuota",
      "hidden": "disembunyikan panitia",
      "sent": "terkirim"
    },
    "join": {
      "closed_hint": "Penerimaan foto sudah ditutup. Kalau kamu sudah pernah masuk, isi namamu untuk melihat fotomu.",
      "name_hint": "Isi namamu supaya fotomu bisa dikenali panitia.",
      "name_placeholder": "Nama kamu",
      "submitting": "Masuk…",
      "submit": "Masuk ke album →",
      "guests": "Tamu",
      "host_message": "Pesan dari host",
      "your_name": "Nama kamu",
      "start": "Mulai memotret"
    },
    "camera": {
      "unavailable": "Kamera nggak bisa dibuka. Kamu masih bisa upload dari galeri lewat tombol foto di kanan bawah.",
      "tap_to_start": "Ketuk untuk menyalakan kamera.",
      "opening": "Membuka…",
      "start": "Nyalakan kamera",
      "switch": "Ganti kamera",
      "shoot": "Ambil foto",
      "upload": "Upload dari galeri",
      "opens": "Dibuka {date}",
      "closed": "Sudah ditutup",
      "time_left": "{time} tersisa",
      "saved": "Tersimpan",
      "flash_on": "Nyalakan flash",
      "flash_off": "Matikan flash",
      "zoom": "Zoom",
      "qr": "Tampilkan QR album",
      "qr_title": "Ajak tamu lain",
      "left_one": "Sisa {count} foto",
      "left_other": "Sisa {count} foto",
      "shots": "Jepretan",
      "ideas": "Ide foto",
      "idea_1": "momen bersulang",
      "idea_2": "dansa pertama",
      "idea_3": "seseorang yang lagi ketawa lepas",
      "idea_4": "satu meja kamu, semua masuk",
      "idea_5": "kuenya sebelum dipotong",
      "idea_6": "selfie bareng tuan rumah"
    },
    "gallery": {
      "own_only": "Galeri album ini hanya menampilkan foto milik masing-masing tamu.",
      "countdown_label": "Galeri dibuka dalam",
      "load_failed": "Gagal memuat galeri. Coba muat ulang halaman.",
      "empty": "Belum ada foto.",
      "login_hint": "Masuk album untuk menyukai / berkomentar",
      "like": "Suka",
      "unlike": "Batal suka",
      "like_failed": "Gagal menyukai foto."
    },
    "comments": {
      "loading": "Memuat komentar…",
      "load_failed": "Gagal memuat komentar.",
      "empty": "Belum ada komentar.",
      "placeholder": "Tulis komentar…",
      "send": "Kirim",
      "delete": "Hapus",
      "send_failed": "Gagal mengirim komentar."
    },
    "banner": {
      "in_app": "Kamu membuka lewat aplikasi chat. Buka link ini di Chrome atau Safari supaya kamera bekerja lancar."
    },
    "upload": {
      "send_failed": "Gagal mengirim foto.",
      "connection_lost": "Koneksi terputus saat mengunggah foto.",
      "interrupted": "Terputus sebelum selesai.",
      "put_failed": "Upload {kind} gagal ({status}).",
      "process_failed": "Gagal memproses foto."
    }
  },
  "errors": {
    "bad_key": "Key harus diawali albums/.",
    "bad_urls": "URL upload tidak cocok, minta URL baru.",
    "photo_incomplete": "Data foto tidak lengkap.",
    "email_required": "Email wajib diisi.",
    "id_token_required": "id_token wajib diisi.",
    "quota_fields_required": "Isi jumlah foto atau tamu.",
    "quota_non_negative": "Jumlah kuota harus bilangan bulat tidak negatif.",
    "comment_length": "Komentar 1 sampai {max} karakter.",
    "invalid_device_id": "ID perangkat tidak berlaku.",
    "name_length": "Nama harus 1 sampai 40 karakter.",
    "invalid_after": "Parameter after tidak berlaku.",
    "oauth_failed": "Verifikasi Google gagal, coba lagi.",
    "bad_signature": "Tanda tangan webhook tidak sah.",
    "account_not_found": "Akun tidak ditemukan.",
    "not_joined": "Kamu belum masuk album.",
    "not_signed_in": "Kamu belum masuk.",
    "unknown_device": "Perangkat tidak dikenal.",
    "session_invalid": "Sesi tidak berlaku, silakan masuk lagi.",
    "token_invalid": "Token tidak berlaku, silakan masuk album lagi.",
    "likes_off": "Fitur like tidak diaktifkan host.",
    "comments_off": "Fitur komentar tidak diaktifkan host.",
    "not_owner": "Album ini bukan milikmu.",
    "admin_only": "Khusus admin.",
    "po_not_allowed": "Bayar via PO hanya untuk mitra, dan hanya untuk paket album.",
    "visibility_own": "Host menyetel galeri hanya menampilkan foto milik masing-masing tamu.",
    "wrong_album": "Token ini untuk album lain.",
    "album_not_found": "Album tidak ditemukan.",
    "cover_not_found": "Cover tidak ada.",
    "endpoint_not_found": "Endpoint tidak ditemukan.",
    "photo_not_found": "Foto tidak ditemukan.",
    "comment_not_found": "Komentar tidak ditemukan.",
    "order_not_found": "Pesanan tidak ditemukan.",
    "already_active": "Album sudah aktif.",
    "device_full": "Album sudah mencapai batas tamu, hubungi panitia.",
    "inactive_pay": "Album belum aktif, selesaikan pembayaran paket dulu.",
    "inactive": "Album belum aktif.",
    "outside_window": "Di luar waktu penerimaan foto.",
    "upload_closed": "Penerimaan foto sudah ditutup.",
    "upload_closed_topup": "Penerimaan foto sudah ditutup, top-up kuota tidak berlaku lagi.",
    "quota_unavailable": "Foto tidak bisa diterima saat ini.",
    "quota_full": "Kuota foto album sudah habis, hubungi panitia.",
    "device_quota": "Kamu sudah mencapai batas {count} foto.",
    "settings_locked": "Tampilan album sudah dikunci dan tidak bisa diubah lagi.",
    "photo_too_large": "Foto terlalu besar, maksimal 3 MB.",
    "cover_too_large": "Cover maksimal 2 MB.",
    "trial_used": "Uji coba gratis hanya bisa sekali per akun.",
    "comment_rate": "Terlalu banyak komentar, tunggu sebentar.",
    "rate_limited": "Terlalu banyak permintaan, tunggu sebentar.",
    "internal": "Terjadi kesalahan.",
    "missing_files": "Sebagian file belum terunggah.",
    "gallery_mode_invalid": "Waktu tampil galeri tidak berlaku.",
    "gallery_delay_min": "Jeda galeri minimal 1 menit.",
    "title_length": "Judul harus 1 sampai 80 karakter.",
    "host_message_length": "Pesan untuk tamu maksimal 280 karakter.",
    "event_time_invalid": "Waktu acara tidak berlaku.",
    "end_before_start": "Waktu selesai harus setelah waktu mulai.",
    "film_filter_invalid": "Filter film tidak berlaku.",
    "filter_invalid": "Filter tidak berlaku.",
    "guests_invalid": "Jumlah tamu tidak berlaku.",
    "photos_per_guest_invalid": "Foto per orang tidak berlaku.",
    "end_extend_only": "Waktu selesai hanya bisa diperpanjang.",
    "cover_jpeg": "Cover harus JPEG.",
    "cover_empty": "Cover kosong.",
    "order_kind_invalid": "Jenis pesanan tidak berlaku.",
    "payment_method_invalid": "Metode bayar tidak berlaku.",
    "settings_required": "Pengaturan \"{field}\" wajib dipilih.",
    "settings_invalid_value": "Nilai pengaturan \"{field}\" tidak berlaku.",
    "settings_invalid": "Pengaturan album tidak berlaku.",
    "settings_unknown": "Pengaturan \"{field}\" tidak dikenal.",
    "settings_bool": "Pengaturan \"{field}\" harus true/false."
  },
  "landing": {
    "create_album": "Buat album",
    "hero_1": "Satu QR,",
    "hero_2": "semua momen tamu.",
    "hero_desc": "Pasang satu QR di acaramu. Tamu memotret dari HP masing-masing, dan setiap foto langsung terkumpul di satu galeri bersama.",
    "testimonials_label": "Kata mereka",
    "testimonials_sub": "Cerita dari host yang sudah memakai Qreate Moment.",
    "quote_1": "Foto terbaik",
    "quote_em": "datang dari mereka yang",
    "quote_2": "benar-benar menikmati pestanya",
    "testimonial_tag_wedding": "Pernikahan",
    "testimonial_tag_birthday": "Ulang tahun",
    "testimonial_tag_corporate": "Acara kantor",
    "testimonial_quote_1": "Tamu tinggal scan QR di meja, dan besok paginya kami sudah punya ratusan foto candid yang nggak sempat ditangkap fotografer.",
    "testimonial_quote_2": "Semua teman ikut motret dari HP masing-masing. Nggak ada lagi drama nagih foto di grup WhatsApp.",
    "testimonial_quote_3": "Gathering 200 orang, satu QR di tiap meja. Galeri langsung jadi bahan konten internal minggu itu juga.",
    "how_it_works_label": "Cara kerja",
    "how_heading_1": "Tiga langkah,",
    "how_heading_em": "tanpa ribet.",
    "step1_body": "Isi nama acara, pilih gaya film, dan tentukan jumlah tamu. Selesai dalam dua menit.",
    "step2_title": "Bagikan satu QR",
    "step2_body": "Cetak QR di meja atau kirim link. Tamu langsung motret dari browser, tanpa aplikasi.",
    "step3_title": "Semua foto terkumpul",
    "step3_body": "Setiap jepretan masuk ke satu galeri lengkap dengan nama tamunya. Unduh semuanya sekali klik.",
    "pricing_label": "Harga",
    "pricing_heading_1": "Bayar sekali,",
    "pricing_heading_em": "per jumlah tamu.",
    "pricing_sub": "Tanpa langganan. Jumlah foto per tamu bebas kamu atur.",
    "trial_label": "Uji coba",
    "trial_detail": "Gratis · {guests} tamu · {days} hari",
    "tier_guests": "Hingga {guests} tamu",
    "tier_per_guest": "≈ {price} per tamu",
    "faq_heading_1": "Pertanyaan?",
    "faq_heading_em": "Kami bantu.",
    "faq1_q": "Apakah tamu perlu mengunduh aplikasi?",
    "faq1_a": "Tidak. Tamu cukup memindai QR atau membuka link, lalu memotret langsung dari browser HP.",
    "faq2_q": "Apakah tamu perlu daftar akun?",
    "faq2_a": "Tidak. Tamu hanya mengisi nama supaya setiap foto tercatat siapa pemotretnya.",
    "faq3_q": "Kapan foto bisa dilihat semua orang?",
    "faq3_a": "Kamu yang menentukan: langsung, setelah acara selesai, atau beberapa jam setelahnya. Tamu selalu bisa melihat fotonya sendiri.",
    "faq4_q": "Berapa lama foto disimpan?",
    "faq4_a": "30 hari sejak acara selesai, dan bisa diperpanjang. Kami kirim pengingat sebelum album dihapus.",
    "faq5_q": "Bagaimana cara bayarnya?",
    "faq5_a": "Lewat QRIS, sekali bayar per album. Harga hanya ditentukan jumlah tamu.",
    "footer_tagline": "Setiap tamu, satu lensa.",
    "footer_login": "Masuk",
    "sticky_note": "Gratis {guests} tamu · tanpa daftar",
    "hero_title_1": "Setiap momen",
    "hero_title_is": "cukup",
    "hero_title_2": "Sekali scan",
    "hero_title_away": "saja",
    "cta_try": "Coba gratis",
    "ready_1": "Siap untuk",
    "ready_em": "Create Moment?",
    "more_q_1": "Masih ada",
    "more_q_em": "pertanyaan?",
    "contact_us": "Hubungi kami"
  },
  "host": {
    "logout": "Keluar",
    "untitled": "Tanpa judul",
    "qr": {
      "preparing": "Menyiapkan QR…",
      "alt": "QR code album",
      "copy": "Salin link",
      "copied": "Tersalin!",
      "download": "Unduh QR"
    },
    "login": {
      "subtitle": "Masuk untuk membuat dan mengelola album acaramu.",
      "opening_google": "Membuka Google…",
      "google": "Masuk dengan Google",
      "google_failed": "Login Google gagal, coba lagi.",
      "dev_mode": "Mode dev: masuk tanpa Google.",
      "dev_button": "Masuk (dev)",
      "back_home": "← Kembali ke beranda"
    },
    "wizard": {
      "duration": {
        "h1": "1 jam",
        "h2": "2 jam",
        "h4": "4 jam",
        "h12": "12 jam",
        "d1": "1 hari",
        "d2": "2 hari",
        "d3": "3 hari"
      },
      "mode": {
        "immediate": "Selama acara",
        "after_event": "Setelah acara",
        "delayed": "Penundaan tambahan"
      },
      "camera_required": "Kamera belum dipilih.",
      "titles": {
        "wedding_0": "Pernikahan Kami",
        "wedding_1": "Hari Bahagia Kami",
        "wedding_2": "Cinta Abadi",
        "wedding_3": "Janji Suci Kami",
        "birthday_0": "Pesta Ulang Tahun",
        "birthday_1": "Tambah Usia, Tambah Bahagia",
        "birthday_2": "Rayakan Bersama",
        "birthday_3": "Hari Spesialku",
        "baby_shower_0": "Menyambut Si Kecil",
        "baby_shower_1": "Baby Shower Kami",
        "baby_shower_2": "Halo, Dunia!",
        "baby_shower_3": "Buah Hati Kami",
        "travel_0": "Liburan Bersama",
        "travel_1": "Jalan-Jalan Seru",
        "travel_2": "Cerita Perjalanan",
        "travel_3": "Petualangan Kami",
        "corporate_0": "Gathering Kantor",
        "corporate_1": "Malam Apresiasi",
        "corporate_2": "Rapat Tahunan",
        "corporate_3": "Ulang Tahun Perusahaan",
        "other_0": "Momen Bersama",
        "other_1": "Kumpul Seru",
        "other_2": "Malam Istimewa",
        "other_3": "Cerita Hari Ini"
      },
      "head": {
        "event": {
          "title": "Acara apa yang kamu rayakan?",
          "sub": "Kami siapkan tampilan yang pas untuk acaramu."
        },
        "title": {
          "title": "Beri nama acaramu",
          "sub": "Nama ini muncul di undangan dan album tamu."
        },
        "camera": {
          "title": "Pilih kamera untuk tamu",
          "sub": "Semua foto tamu diambil dengan gaya ini."
        },
        "filter": {
          "title": "Pilih film",
          "sub": "Karakter warna untuk setiap jepretan."
        },
        "format": {
          "title": "Ukuran foto instant",
          "sub": "Bentuk bingkai foto yang dicetak."
        },
        "card": {
          "title": "Kartu undanganmu",
          "sub": "Ini yang dilihat tamu saat membuka link."
        },
        "reveal": {
          "title": "Kapan foto terlihat?",
          "sub": "Buat kejutan, atau bagikan sepanjang acara."
        },
        "visibility": {
          "title": "Siapa bisa lihat foto?",
          "sub": "Atur privasi album tamu."
        },
        "interaction": {
          "title": "Biar tamu ikut meramaikan",
          "sub": "Nyalakan yang kamu suka."
        },
        "date": {
          "title": "Kapan acaramu?",
          "sub": "Kamera tamu terbuka selama acara berlangsung."
        },
        "guests": {
          "title": "Berapa tamu?",
          "sub": "Harga ditentukan jumlah tamu."
        }
      },
      "editable_later": "Bisa diubah nanti",
      "trial_badge": "Uji coba gratis · {guests} tamu × {photos} foto · {days} hari",
      "starting_from": "Mulai {price}",
      "create_failed": "Gagal membuat album.",
      "saving": "Menyimpan…",
      "create": "Buat album",
      "next": "Lanjut →",
      "cover_upload_failed_alert": "Cover gagal diunggah. Unggah ulang di halaman album setelah pembayaran.",
      "title": {
        "placeholder": "Pernikahan Andi & Bela",
        "suggestions_label": "SARAN"
      },
      "camera": {
        "analogue_label": "Analogue",
        "analogue_hint": "Foto penuh berkarakter film",
        "instant_label": "Instant",
        "instant_hint": "Bingkai putih ala polaroid"
      },
      "format": {
        "hint_mini": "2:3 tegak"
      },
      "card": {
        "change_cover": "Ganti cover",
        "upload_cover": "Unggah cover",
        "remove": "Hapus",
        "no_cover_hint": "Tanpa cover, kami pakai foto bawaan {type}.",
        "message_label": "Pesan untuk tamu (opsional)",
        "message_placeholder": "Terima kasih sudah datang! Abadikan momen favoritmu.",
        "title_placeholder": "Nama acaramu",
        "name_placeholder": "Masukkan namamu",
        "enter_album": "Masuk ke album →"
      },
      "reveal": {
        "immediate_hint": "Foto langsung tampil di album begitu diambil.",
        "after_event_hint": "Album terbuka saat acara selesai.",
        "delayed_label": "Jeda tambahan",
        "delayed_hint": "Kejutan: album terbuka beberapa saat setelah acara.",
        "delay_label": "Jeda setelah acara selesai",
        "custom_minutes_label": "Atau tulis sendiri (menit)"
      },
      "visibility": {
        "all_label": "Semua orang",
        "all_hint": "Setiap tamu bisa melihat foto semua tamu.",
        "own_label": "Foto sendiri",
        "own_hint": "Tamu hanya melihat foto yang dia ambil. Kamu tetap melihat semuanya."
      },
      "interaction": {
        "sample_comments": "✎ 3 ucapan",
        "no_extras": "Tanpa like & komentar",
        "likes_label": "Like foto",
        "likes_hint": "Tamu bisa memberi ♥",
        "comments_label": "Komentar",
        "comments_hint": "Tamu bisa menulis ucapan di foto"
      },
      "date": {
        "date_label": "Tanggal",
        "time_label": "Jam mulai",
        "duration_label": "BERAPA LAMA"
      },
      "guests": {
        "up_to_label": "Hingga",
        "count_one": "{count} tamu",
        "count_other": "{count} tamu",
        "upgrade_hint": "Bisa di-upgrade kapan pun",
        "slider_aria": "Jumlah tamu",
        "photos_per_guest_label": "FOTO PER ORANG"
      }
    },
    "list": {
      "title": "Album saya",
      "try_free": "Coba gratis",
      "loading": "Memuat album…",
      "load_failed": "Gagal memuat album. Coba muat ulang halaman.",
      "empty": "Belum ada album. Mulai dari uji coba gratis ({guests} tamu, {days} hari) atau langsung buat album.",
      "status": {
        "active": "Aktif",
        "pending_payment": "Menunggu pembayaran",
        "draft": "Draf",
        "expired": "Kedaluwarsa",
        "done": "Selesai"
      },
      "photos_count_one": "{count}/{total} foto",
      "photos_count_other": "{count}/{total} foto"
    },
    "album": {
      "pending_desc": "Album belum bisa menerima foto sampai pembayaran lunas.",
      "pay_now": "Bayar sekarang",
      "upload_closed": "Penerimaan foto sudah ditutup.",
      "topup": "Top-up kuota",
      "extend": "Perpanjang",
      "guests_heading": "Orang ({count})",
      "no_guests": "Belum ada tamu yang bergabung.",
      "guest_untitled": "Tanpa nama",
      "guest_photo_count_one": "{count} foto",
      "guest_photo_count_other": "{count} foto",
      "photo_alt": "Foto dari {name}",
      "uploading": "Mengunggah…",
      "show": "Tampilkan",
      "hide": "Sembunyikan",
      "comments_open": "Komentar",
      "no_photos": "Belum ada foto.",
      "load_more": "Muat lebih banyak",
      "not_found": "Album tidak ditemukan.",
      "comment_delete_failed": "Gagal menghapus komentar.",
      "comments_load_failed": "Gagal memuat komentar.",
      "cover_title": "Cover undangan",
      "cover_alt": "Cover album",
      "cover_default_alt": "Cover default",
      "cover_default_badge": "Default",
      "cover_change": "Ganti",
      "cover_upload": "Unggah",
      "cover_remove": "Hapus",
      "cover_hint": "Tampil di halaman tamu dan saat link dibagikan.",
      "message_title": "Pesan untuk tamu",
      "message_hint": "Tampil saat tamu bergabung. Opsional, maks 280 karakter.",
      "message_save": "Simpan pesan",
      "message_saved": "Tersimpan",
      "message_failed": "Pesan gagal disimpan.",
      "cover_failed_query": "Cover gagal diunggah — unggah ulang di bawah.",
      "cover_upload_failed": "Cover gagal diunggah.",
      "cover_delete_failed": "Cover gagal dihapus.",
      "settings": {
        "camera_analogue": "Analogue Film",
        "camera_instant": "Instant Film"
      },
      "download_zip": "Unduh semua (zip)",
      "download_preparing": "Menyiapkan zip… {done} dari {total}",
      "download_failed": "Gagal, coba lagi"
    },
    "pay": {
      "kind": {
        "package": "Paket album",
        "topup_photo": "Top-up 100 foto",
        "topup_device": "Top-up 50 tamu",
        "extend_retention": "Perpanjang 30 hari"
      },
      "paid_title": "Pembayaran diterima 🎉",
      "paid_desc": "Album diperbarui, kembali ke halaman album…",
      "back": "← Kembali ke album",
      "title": "Pembayaran",
      "package_summary": "Paket {guests} tamu × {photos} foto",
      "total": "Total {amount}",
      "choose_purchase": "Pilih pembelian",
      "method": "Metode bayar",
      "method_po": "Bayar via PO (mitra)",
      "create_pending": "Membuat tagihan…",
      "create": "Buat tagihan",
      "po_pending_title": "Menunggu verifikasi admin",
      "po_pending_desc": "Tagihan {amount} tercatat. Album aktif setelah admin memverifikasi PO.",
      "qris_hint": "Pindai dengan aplikasi pembayaran, halaman ini memperbarui sendiri.",
      "dev_simulate": "Simulasikan bayar (dev)"
    }
  },
  "admin": {
    "title": "Panel admin",
    "forbidden": "Khusus admin.",
    "po_pending_heading": "PO menunggu verifikasi",
    "po_empty": "Tidak ada PO menunggu.",
    "activate": "Aktifkan",
    "emergency_heading": "Tambah kuota darurat",
    "id_placeholder": "ID album",
    "photos_placeholder": "Foto",
    "guests_placeholder": "Tamu",
    "add": "Tambah",
    "quota_result": "Kuota jadi {photos} foto / {guests} tamu."
  },
  "event": {
    "camera": "Buka kamera",
    "add_photo": "Tambah foto",
    "join_title": "Siapa namamu?",
    "stat": {
      "moments": "Momen",
      "left": "Tersisa",
      "opens_in": "Dibuka dalam",
      "ended": "Selesai",
      "people": "Orang"
    },
    "upgrade": {
      "label": "Upgrade acara ini?",
      "title": "Tambah pax",
      "trial_sub": "Paket gratis dibatasi {count} tamu",
      "sub": "{used} dari {quota} tamu sudah bergabung"
    },
    "settings": {
      "title": "Pengaturan Acara",
      "name": "Nama acara",
      "start": "Mulai",
      "end": "Berakhir",
      "reveal": "Waktu ungkap",
      "per_guest": "Foto per orang",
      "camera_filter": "Kamera & filter",
      "camera_frame": "Kamera & bingkai",
      "visibility": "Siapa bisa lihat",
      "expires": "Masa aktif"
    },
    "tab_label": "Foto",
    "tab_all": "Semua foto",
    "tab_mine": "Foto saya",
    "meta_photos_one": "{count} foto",
    "meta_photos_other": "{count} foto",
    "meta_guests_one": "{count} tamu",
    "meta_guests_other": "{count} tamu"
  }
}
